import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { ProblemDetails } from '@mapa/esm';
import { catchError } from 'rxjs';
import { MapaApi } from './mapa.api';

export const mapaApiInterceptor: HttpInterceptorFn = (req, next) => {
  if (!MapaApi.shouldIntercept(req))
    return next(req);

  return next(req)
    .pipe(
      catchError(err => {
        let errorSource;

        if (err instanceof HttpErrorResponse) {
          if (err.headers.get('content-type')?.includes('application/problem+json')) {
            if (typeof err.error === 'string') {
              errorSource = JSON.parse(err.error);
            }
            else {
              errorSource = err.error;
            }
          }
        }
        else {
          errorSource = err;
        }

        let pd;
        try {
          pd = ProblemDetails.fromObject(errorSource);
        }
        catch {
          pd = new ProblemDetails();
          pd.type = 'unknown-error';
          pd['error'] = errorSource;
          pd['url'] = req.url;
        }
        throw pd;
      })
    );
};
